import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { addMatomoEvent } from '@autobid/ui/utils/addMatomoEvent'

export default defineNuxtPlugin(async () => {
  const auth = useAutobidAuth()
  if (auth.intent === 'login' && auth.isAuthed) {
    const accessToken = auth.sessionData.value?.accessToken
    if (!accessToken)
      return
    const tokenData = auth.getTokenData()
    if (!tokenData)
      return
    addMatomoEvent({
      event: 'login',
      user_email: tokenData.email,
      user_id: tokenData.id,
    })
  }
})
